import React, { useMemo } from 'react';
import { formatDate } from '@/utils/date';
import { gql } from '@apollo/client';
import { MultiStyleText } from '@/components/multi-style-text';
import { OrderFulfillmentDateFieldsFragment } from '@/types';
import { StyleProp, TextStyle } from 'react-native';

export const ORDER_FULFILLMENT_DATE_FRAGMENT = gql`
  fragment OrderFulfillmentDateFields on orders {
    fulfillment_timeslot_end
    fulfillment_timeslot_start
    order_tracking {
      order_completed_delivery_datetime
      uuid
    }
    restaurant_desired_delivery_time
    supplier_accepted_delivery_time
    uuid
  }
`;

interface Props {
  dateTranslator: (orderDate: { date: string }) => string;
  order: OrderFulfillmentDateFieldsFragment;
  textStyle: StyleProp<TextStyle>;
}

export const OrderFulfillmentDate: React.FC<Props> = ({
  dateTranslator,
  order,
  textStyle,
}) => {
  const formattedDate = useMemo(() => {
    const dateString =
      formatDate(
        order.order_tracking?.order_completed_delivery_datetime ||
          order.supplier_accepted_delivery_time ||
          order.restaurant_desired_delivery_time,
      ) || '';

    const timeslotStart = order.fulfillment_timeslot_start;
    const timeslotEnd = order.fulfillment_timeslot_end;
    if (!timeslotStart || !timeslotEnd) {
      return dateString;
    }

    return dateString;
  }, [order]);

  return (
    // Use MultiStyleText since the translation is shared with OrderSummary
    // and contains tags for emphasis
    <MultiStyleText defaultStyle={textStyle} emphasisStyle={textStyle}>
      {dateTranslator({
        date: formattedDate,
      })}
    </MultiStyleText>
  );
};
